export type WorldTheme = 'outdoors' | 'city' | 'office';
export type CareerLevel = 'admin' | 'paralegal' | 'attorney' | 'partner';

export interface FlagSet {
  'theme.world': WorldTheme;
  'ability.runFaster': boolean;
  'ability.carryMore': boolean;
  'office.expressLane': boolean;
  'career.startLevel': CareerLevel;
  'career.fastTrack': boolean;
  'world.seed': number;
}

export const flagDefaults: FlagSet = {
  'theme.world': 'outdoors',
  'ability.runFaster': false,
  'ability.carryMore': false,
  'office.expressLane': false,
  'career.startLevel': 'admin',
  'career.fastTrack': false,
  'world.seed': 1
};

export type FlagKey = keyof FlagSet;
